<template>
  <ITMPage>
    <v-form class="container" @input="formValid = $event" ref="form">
      <h2 class="col-12">Search</h2>
      <div class="hvh-flex wrap space-between">
        <v-select class="col-12" :items="searchType" v-model="formData.searchType" item-value="id" item-text="name" label="Search Type" :rules="requiredRules" />
        <v-select class="col-12" :items="documentType" v-model="formData.documentType" item-value="id" item-text="name" label="Document Type" :rules="requiredRules" v-if="formData.searchType === 1" />
        <v-select class="col-12" :items="categories" v-model="formData.categories" item-value="id" item-text="name" label="Category"  v-if="formData.searchType === 1" />

        <v-text-field v-if="formData.documentType !== 2" class="col-12" label="Enter PO # " v-model="formData.search" :rules="requiredRules"  />
        <v-autocomplete v-if="formData.documentType === 2 && formData.searchType === 1"
  class="col-12"
  v-model="formData.searchCustomer"
  :items="customerDeatils"
  item-value="value"
  item-text="label"
  label="Enter Customer Number or Customer Name"
  :rules="requiredRules"
  @change="onCustomerSelected"
></v-autocomplete>
        <div class="hvh-flex end col-12">
          <v-btn flat class="hvh-btn hvh-btn--primary p-0 m-1" @click="submitTracking">Search</v-btn>
          <v-btn flat class="hvh-btn hvh-btn--primary m-1" @click="submitReset">Reset</v-btn>
        </div>
      </div>

      <div class="mt-3">
        <ITMDocuments class="col-12" :documents="documentations" v-if="!statusMessage && documentations" />
        <template >
          <div class="col-12" v-if="statusMessage">
            <v-alert border="top" type="warning" color="red" outline :value="true" v-if="statusMessage">
              {{ statusMessage }}
            </v-alert>
          </div>
          <ExcelExporter :data="searchgridData" :columns="excelColumns" :fileName="excelFileName" />
          <ITMSearchGrid  :data="searchgridData" @view-order-details="fetchOrderDetails" v-if="!statusMessage && searchgridData " />
        </template>
      </div>

      <ITMCreateOrder :value="orderDetails" :isLoading="isLoading" :readOnly="true" @close="orderDetails = null" v-if="orderDetails" />
    </v-form>
  </ITMPage>
</template>


<script>
import ITMPage from '../../components/itm/ITMPage.vue';
import ITMCreateOrder from '../../components/itm/ITMCreateOrder.vue'
import ITMDocuments from '../../components/itm/ITMDocuments.vue';
import axios from '../../axios';
import ExcelExporter from '../../components/itm/ITMExcelExporter.vue';
import ITMSearchGrid from '../../components/itm/ITMSearchGrid.vue';
import { errorDebug, createFormData } from '../../libraries/common';

export default {
  components: { ITMPage, ITMDocuments, ITMSearchGrid, ITMCreateOrder ,ExcelExporter },
  data() {
    return {
      requiredRules: [v => !!v || v === false || 'Field is required'],
      formData: {
        documentType: null,
        searchCustomer: null,
        categories: null,
        search: ''
      },
      data: null,
      orderDetails: null,
      isLoading: false,
      trackingNumber: '',
      statusMessage: '',
      categories: [],
      customerDeatils:[],
      searchgridData: null,
      documentations: null,
      documentType: [
        { id: 1, name: "Order" },
        { id: 2, name: "Customer" }
      ],
      searchType: [
        { id: 1, name: "Documents Search" },
        { id: 2, name: "Order Search" }
      ],
       excelColumns: [ // Define your columns here
        { label: 'Order ID', field: 'orderId' },
        { label: 'Product Name', field: 'productName' },
        { label: 'Customer Name', field: 'customerName' },
        { label: 'Order Status', field: 'orderStatus' },
        { label: 'Order Date', field: 'orderDate' }
       
      ],
      excelFileName: 'order_reports.xlsx',
      isLoadingCategories: false,
      formValid: true,
    };
  },
  methods: {
    getData() {
      this.isLoading = true;
      axios.get(`/api/ITM/Orders`)
        .then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    fetchCustomerOptions() {
      this.isLoading = true;
      axios.get(`/ITM/DashBoard/GetDdlCustomer`)
        .then(({ data }) => this.customerDeatils = data.map(item => ({
          value: item.customerNumber,
          label:`${item.customerNumber} - ${item.name}`
        })))
        .catch(Error)
        .then(() => this.isLoading = false);
    },
    clearFormFields() {
    this.formData.documentType = null;
    this.formData.categories = null;
    this.formData.search = '';
    this.formData.searchCustomer = null;
    this.searchgridData = null;
    this.documentations = null;
    this.orderDetails = null;
    this.statusMessage = '';
  },
    submitReset() {
      
      window.location.reload();
    },
    submitTracking() {
     
      if (!this.$refs.form.validate()) return;
      if (!this.formData.searchType) {       
        this.$bvToast.toast('Search Type is required', {
          title: 'Error',
          variant: 'danger'
        });
        return;
      }
      if (this.formData.search.trim() !== '' ||  this.formData.searchCustomer !== '') {
        if (this.formData.searchType !== 1) {

          this.isLoading = true;
          axios.post(`/ITM/Search/SearchGridData`, createFormData({ OrderId: this.formData.search.trim() }))
            .then(({ data }) => {
              this.searchgridData = data;
              this.documentations = null;
                if (!data.length) {
                this.statusMessage = 'No Record found with this Selection';
              } else {
                this.statusMessage = '';
              }
            })
            .catch(error => {
              console.error('Error submitting tracking:', error);
              this.statusMessage = 'Unfortunately, we are unable to retrieve your tracking results at this time. Please try again later.';
            })
            .finally(() => {
              this.isLoading = false;
            });
        } else {
          var searchData = {
            DocumentType: this.formData.documentType,
            Category: this.formData.categories || 0,
            Search: this.formData.search.trim(),
            Customer:this.formData.searchCustomer
          };

          axios.post('/ITM/Search/GetDocument', searchData)
            .then(response => {
             
              this.documentations = response.data;
              this.searchgridData = null;
              if (!response.data.length) {
                this.statusMessage = 'No Record found with this Selection';
              } else {
                this.statusMessage = '';
              }
            })
            .catch(error => {
              console.error('Error fetching data:', error);
              this.statusMessage = 'Unfortunately, we are unable to retrieve your tracking results at this time. Please try again later.';
            });
        }

      } else {
        alert('Please enter a valid Input');
      }
    },
    fetchOrderDetails(orderId, orderKey) {
     
      if (orderId) {
        var orderDetails = this.data.find(f => f.orderId === orderId && f.id === orderKey);
        if (orderDetails) {
          this.orderDetails = orderDetails;
        } else {
          console.error('Order details not found.');
        }
      } else {
        console.error('Invalid orderId.');
      }
    },
    getCategories() {
      this.isLoadingCategories = true;
      axios.get(`/api/ITM/DocumentCategories`)
        .then(({ data }) => {
          this.categories = data;
        })
        .catch(error => {
          console.error('Error fetching categories:', error);
        })
        .finally(() => {
          this.isLoadingCategories = false;
        });
    },
  },
  watch: {
  'formData.searchType': function() {
    this.clearFormFields();
  },
  'formData.documentType': function() {
    this.formData.categories = null;
    this.formData.search = '';
    this.formData.searchCustomer = null;
    this.searchgridData = null;
    this.documentations = null;
    this.orderDetails = null;
    this.statusMessage = '';
  },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMSearch'] = this;
    this.getData();
    this.getCategories();
    this.fetchCustomerOptions();
  }
};
</script>
